import Vue from 'vue'

export default {
  SET_LOADING(state, loading) {
    Vue.set(state, 'loading', loading)
  },
  SET_EMPRESAS(state, empresas) {
    Vue.set(state, 'empresas', [...empresas])
  },
  SET_ANEXOS(state, anexos) {
    Vue.set(state, 'anexos', [...anexos])
  },
  SET_UNIDADES(state, unidades) {
    unidades.forEach(value => {
      value.descricao = `${value.bloco}${value.nome}`
    })
    Vue.set(state, 'unidades', [...unidades])
  },
  SET_INTERESSES(state, interesses) {
    Vue.set(state, 'interesses', [...interesses])
  },
}
